export const isRetailerLocationDefault = retailerLocation => retailerLocation.default_retailer_location;
export const isRetailerLocationKiosk = retailerLocation => retailerLocation.is_kiosk;
